import React from 'react';
import FileSelect from './FileSelect';

const ChartScreen = () => (
  <div className="container">
    <FileSelect rawTable />
    <FileSelect rawTable />
    <FileSelect rawTable />
  </div>
);

export default ChartScreen;